import {gql} from "@irati/utils/gql"

const fullCreationMetadata = gql`
  fragment fullCreationMetadata on BusinessCreationMetadata {
    businessId
    createdById
    createdBy {
      uuid
      email
      fullName
    }
    createdAt
    reasonForCreation
    details
  }
`
export default fullCreationMetadata
